module.exports = __webpack_public_path__ + "d1552c1e4b17ab9a6b147386165ab5ec.MP3";